<template>
  <div class="voucher-list" >
    <h3 class="group-hd" v-if="groupIndex === 0">{{categoryName}}</h3>
    <ul class="voucher-group">
      <li class="voucher-group-list">
          <span class="voucher-hd">
            <div class="voucher-title" :style="'color: #' + groupInfo.color" v-if="productType !== 'one' && productType !== 'package'">{{groupInfo.productgroup_name}}</div>
            <div class="question-popup-wrap" v-if="productType !== 'one' && productType !== 'package'">
              <button type="button" v-if="isDescription" :class="tooltipToggle ? 'question-btn on' : 'question-btn' " @click.prevent="clickTooltip(tooltipToggle)"></button>
              <span class="question-popup" v-if="tooltipToggle"> <!--question-popup-->
                <span class="question-txt">시청 가능 콘텐츠<br />{{groupInfo.description}}</span>
                <button type="button" class="btn-popup-close" @click="close()">
                  <span class="a11y-hidden">닫기</span>
                </button>
              </span>
            </div>
          </span>
         <all-products-new :list-info="groupInfo.products"
                       :product-type="productType"
                       :user-line="userLine"
                       :group-name="groupInfo.productgroup_name"
                       :group-index="groupIndex"
                       :category-index="categoryIndex"
                       :key="'currentGroupIndex_'+currentIndex"
                       :current-index="currentIndex"
                       :set-number-commas="setNumberCommas"/>
      </li>
    </ul>
  </div>
</template>

<script>
import AllProductsNew from '@/components/voucher/AllProductsNew'
import { get } from 'lodash'
export default {
  name: 'AllProductGroupsNew',
  components: {
    AllProductsNew
  },
  props: {
    groupInfo: {
      type: Object
    },
    categoryName: {
      type: String
    },
    productType: {
      type: String
    },
    groupIndex: {
      type: String
    },
    userLine: {
      type: String
    },
    categoryIndex: {
      type: Number
    },
    currentIndex: {
      type: String
    },
    setNumberCommas: {
      type: Function
    }
  },
  data () {
    return {
      tooltipToggle: false
    }
  },
  computed: {
    isDescription () {
      let text = get(this.groupInfo, 'description', '')
      return text.trim() !== ''
    },
    colorStyle () {
      return { color: this.groupInfo.style }
    }
  },
  methods: {
    clickTooltip (toggle) {
      this.tooltipToggle = !toggle
    },
    close () {
      this.tooltipToggle = false
    }

  }
}
</script>
<style scoped>
  .voucher-list{
    padding-bottom: 20px;
  }
  .question-popup{
    bottom: auto;
    top: 30px;
  }
</style>
